import {Switch as BaseSwitch} from '@logistics-frontend/blocks'
import {type ReactElement, useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import type {OrderFormState} from '../../types'
import {type WidgetPropsByType, WidgetType} from '../types'

/**
 * Компонент свитчера.
 */
export const Switch = ({enabled, name, value: configValue}: WidgetPropsByType<WidgetType.SWITCH>): ReactElement => {
  const {control} = useFormContext<OrderFormState>()
  const {
    field: {onChange, value, ...field},
  } = useController({name, control})

  const handleChange = useCallback(
    (isEnabled: boolean) => {
      // Если пользователь включил свитчер, в значение в стейте записываем value из конфига, иначе - null
      onChange(isEnabled ? configValue : null)
    },
    [configValue, onChange],
  )

  return <BaseSwitch {...field} disabled={!enabled} on={!!value} onChange={handleChange} />
}
